import { render } from "./pano.vue?vue&type=template&id=13988f04"
import script from "./pano.vue?vue&type=script&lang=js"
export * from "./pano.vue?vue&type=script&lang=js"
script.render = render

export default script